import { render, staticRenderFns } from "./html/events-quiz.html?vue&type=template&id=710e72ae&"
import script from "./fusion-imagineer-type-quiz.vue?vue&type=script&lang=js&"
export * from "./fusion-imagineer-type-quiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports